import { Tabs } from 'antd';
import { useNavigate } from 'react-router';
import { PageHeader } from '../../../shared/components/PageHeader';
import { sectionTrail } from '../../../shared/components/section-trail';
import { OwnersPage } from '../features/owners/pages/OwnersPage';
import { UnitsPage } from '../features/units/pages/UnitsPage';
import { FLEET_TAB_LABELS, fleetTabPath, type FleetTab } from '../fleet.paths';

/**
 * The Fleet nav section's landing page. The office thinks of a truck and the trailer it pulls as one unit, named by the truck's
 * registration (gitaumoses4/chukua#390), so trucks and trailers are one Units list; owners keep their own tab.
 */
export function FleetPage({ tab }: { tab: FleetTab }) {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader breadcrumbs={sectionTrail('fleet')} title="Fleet" description="Each truck with the trailer it pulls, the spare trailers, and their owners." />
      <Tabs
        activeKey={tab}
        onChange={(key) => navigate(fleetTabPath(key as FleetTab))}
        items={[
          { key: 'units', label: FLEET_TAB_LABELS.units, children: <UnitsPage /> },
          { key: 'owners', label: FLEET_TAB_LABELS.owners, children: <OwnersPage /> },
        ]}
      />
    </>
  );
}
